
import Vue from "vue";
import BannerSlider from "@/components/banner/BannerSlider.vue";
import HomeCastCard from "@/components/HomeCastCard.vue";
import NewComerCastList from "@/components/cast/NewComerCastList.vue";
import RecommendCastList from "@/components/cast/RecommendCastList.vue";
import { UserType, UserTypes } from "@/types/abstract";
import { ICast, castTypeArray } from "@/types/cast";
import { route_castInfo } from "@/router";
import { FeatureTypes } from "@/types/abstract";
import { arrayShuffle } from "@/helper/utils/arrayUtils";
import {
  area_hokkaido,
  area_kansai,
  area_kanto,
  area_kyusyu,
  prefecture_list,
} from "@/helper/constants";

interface ICastTab {
  [name: string]: string;
}

export default Vue.extend({
  name: "Home",
  components: {
    HomeCastCard,
    BannerSlider,
    NewComerCastList,
    RecommendCastList,
  },
  data(): {
    userList: ICast[];
    displayUserList: ICast[];
    newComerCastList: ICast[];
    recommendList: ICast[];
    userType: UserType;
    tabList: ICastTab[];
    selectedTab: string;
  } {
    return {
      userList: [],
      displayUserList: [],
      newComerCastList: [],
      recommendList: [],
      userType: UserTypes.None,
      tabList: [
        { id: "all", text: "すべて" },
        { id: "area_kanto", text: "関東エリア" },
        { id: "area_kansai", text: "関西エリア" },
        { id: "area_kyusyu", text: "九州エリア" },
        { id: "area_hokkaido", text: "北海道エリア" },
        { id: "newCommer", text: "新人" },
        { id: "feature_Babyface", text: "童顔" },
        { id: "feature_Pretty", text: "綺麗め" },
        { id: "feature_Tall", text: "身長高め" },
        { id: "feature_Short", text: "身長低め" },
        { id: "rank_Premium", text: "ランク:プレミアム" },
        { id: "rank_Standard", text: "ランク:スタンダード" },
        { id: "rank_Economy", text: "ランク:エコノミー" },
      ],
      selectedTab: "all",
    };
  },
  async created() {
    const userType = this.$store.getters["auth/getUserType"];
    this.userType = userType;
    if (userType == UserTypes.Guest) {
      try {
        const newCommerList = this.$store.getters["castList/getNewCommerList"];
        if (newCommerList.length > 0) {
          this.newComerCastList = newCommerList;
        } else {
          // キャスト情報の取得
          this.$store.dispatch("castList/fetchNewCommerList").then((res) => {
            this.newComerCastList = res.reverse();
          });
        }

        const castList = this.$store.getters["castList/getCastList"];
        if (castList.length > 0) {
          this.userList = castList;
          this.displayUserList = this.userList;
          this.setReccomendList();
          return;
        }
        this.$store.dispatch("castList/fetchCastList").then((res) => {
          this.userList = arrayShuffle(res);
          this.displayUserList = this.userList;
          this.setReccomendList();
        });
      } catch (error) {
        alert(
          "キャスト情報取得中にエラーが発生しました。画面を再度リロードするか時間をおいておためしください。"
        );
      }
    }
  },
  computed: {
    topCastList: function(): ICast[] {
      return this.displayUserList.slice(0, 10);
    },
    underCastList: function(): ICast[] {
      if (this.displayUserList.length <= 10) {
        return [];
      }
      return this.displayUserList.slice(10);
    },
  },
  methods: {
    isGuest(): boolean {
      return this.userType == UserTypes.Guest;
    },
    toUserInfoPage(data: ICast) {
      this.$store.dispatch("cast/setCastData", data);
      this.$router.push(route_castInfo + data.uid);
    },
    setReccomendList() {
      this.recommendList = [];
      for (let i = 1; i < 6; i++) {
        if (this.userList.length < i) {
          break;
        }
        this.recommendList.push(this.userList[this.userList.length - i]);
      }
    },
    updateCastList() {
      try {
        // キャスト情報の取得
        this.$store.dispatch("castList/fetchNewCommerList").then((res) => {
          this.newComerCastList = res.reverse();
        });

        this.$store.dispatch("castList/fetchCastList").then((res) => {
          this.userList = arrayShuffle(res);
          this.displayUserList = this.userList;
          this.selectedTab = "all";
          this.setReccomendList();
        });
      } catch (error) {
        alert(
          "キャスト情報取得中にエラーが発生しました。画面を再度リロードするか時間をおいておためしください。"
        );
      }
    },
    onClickTab(tab: any) {
      this.selectedTab = tab.id;
      if (tab.id == "all") {
        this.displayUserList = this.userList;
        return;
      }
      if (tab.id == "newCommer") {
        this.displayUserList = arrayShuffle(this.newComerCastList);
        return;
      }

      const tabSplit = tab.id.split("_");
      if (tabSplit[0] == "rank") {
        this._filtterRank(tabSplit[1]);
      }
      if (tabSplit[0] == "feature") {
        this._filtterFeature(tabSplit[1]);
      }
      if (tabSplit[0] == "area") {
        this._filterArea(tabSplit[1]);
      }
    },
    _filtterRank(castRank: keyof typeof castTypeArray) {
      this.displayUserList = this.userList.filter(
        (cast) => cast.castType == castTypeArray[castRank]
      );
    },
    _filtterFeature(feature: keyof typeof FeatureTypes) {
      this.displayUserList = this.userList.filter((cast) =>
        cast.featureTag.includes(FeatureTypes[feature])
      );
    },
    _filterArea(areaName: string) {
      let prefectureList: string[] = [];
      if (areaName == "kanto") {
        prefectureList = area_kanto;
      }
      if (areaName == "kansai") {
        prefectureList = area_kansai;
      }
      if (areaName == "kyusyu") {
        prefectureList = area_kyusyu;
      }
      if (areaName == "hokkaido") {
        prefectureList = area_hokkaido;
      }
      this.displayUserList = this.userList.filter((cast) =>
        prefectureList.includes(cast.prefecture)
      );
    },
  },
});
